var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
var RemoveAltPipe = /** @class */ (function () {
    function RemoveAltPipe() {
    }
    RemoveAltPipe.prototype.transform = function (text) {
        return "Remove " + text;
    };
    RemoveAltPipe = __decorate([
        Pipe({ name: 'removeAlt' })
    ], RemoveAltPipe);
    return RemoveAltPipe;
}());
export { RemoveAltPipe };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVtb3ZlLWFsdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlbW92ZS1hbHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsT0FBTyxFQUFFLElBQUksRUFBaUIsTUFBTSxlQUFlLENBQUM7QUFHcEQ7SUFBQTtJQUlBLENBQUM7SUFIVSxpQ0FBUyxHQUFoQixVQUFpQixJQUFZO1FBQ3pCLE9BQU8sWUFBVSxJQUFNLENBQUM7SUFDNUIsQ0FBQztJQUhRLGFBQWE7UUFEekIsSUFBSSxDQUFDLEVBQUMsSUFBSSxFQUFFLFdBQVcsRUFBQyxDQUFDO09BQ2IsYUFBYSxDQUl6QjtJQUFELG9CQUFDO0NBQUEsQUFKRCxJQUlDO1NBSlksYUFBYSJ9